import { render, staticRenderFns } from "./WorkStatus.vue?vue&type=template&id=fab09214&scoped=true"
import script from "./WorkStatus.vue?vue&type=script&lang=js"
export * from "./WorkStatus.vue?vue&type=script&lang=js"
import style0 from "./WorkStatus.vue?vue&type=style&index=0&id=fab09214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab09214",
  null
  
)

export default component.exports